export var TypeDevice;
(function (TypeDevice) {
    TypeDevice[TypeDevice["Mobile"] = 1] = "Mobile";
    TypeDevice[TypeDevice["Desktop"] = 2] = "Desktop";
})(TypeDevice || (TypeDevice = {}));
export const DEVICE = {
    type: TypeDevice.Desktop,
};
